var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 20.8334C8.33301 12.9767 8.33301 9.0483 10.7738 6.60753C13.2146 4.16675 17.1429 4.16675 24.9997 4.16675C32.8564 4.16675 36.7848 4.16675 39.2256 6.60753C41.6663 9.0483 41.6663 12.9767 41.6663 20.8334V29.1667C41.6663 37.0235 41.6663 40.9519 39.2256 43.3926C36.7848 45.8334 32.8564 45.8334 24.9997 45.8334C17.1429 45.8334 13.2146 45.8334 10.7738 43.3926C8.33301 40.9519 8.33301 37.0235 8.33301 29.1667V20.8334Z",
    stroke: "url(#paint0_linear_3571_1780)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 39.5833H18.75",
    stroke: "url(#paint1_linear_3571_1780)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8916 4.95361L34.7164 5.21646C33.1413 7.57914 32.3537 8.76052 31.2034 9.47533C30.9746 9.61747 30.737 9.74468 30.4918 9.85615C29.259 10.4168 27.8391 10.4168 24.9995 10.4168C22.1599 10.4168 20.7401 10.4168 19.5073 9.85615C19.2621 9.74468 19.0244 9.61747 18.7957 9.47533C17.6454 8.76052 16.8578 7.57917 15.2827 5.21646L15.1074 4.95361",
    stroke: "url(#paint2_linear_3571_1780)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3571_1780",
    x1: 41.6663,
    y1: 25.0001,
    x2: 8.33301,
    y2: 25.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3571_1780",
    x1: 31.25,
    y1: 40.0833,
    x2: 18.75,
    y2: 40.0833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3571_1780",
    x1: 34.8916,
    y1: 7.68519,
    x2: 15.1074,
    y2: 7.68519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F15A24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D72128"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobile);
export default __webpack_public_path__ + "static/media/icon-mobile.a9c7927b98db28017e71539f917fdf9d.svg";
export { ForwardRef as ReactComponent };